import { NavLink } from "react-router";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { FormattedMessage } from "@mnemonic/intl";
import { Link } from "@mnemonic/mui";

import { AuthenticationMethodsList } from "../../Components/AuthenticationMethodsList";
import { VerifyBox } from "../../Components/Login/Layout/Verify/VerifyBox";
import RedirectWrapper from "../Login/RedirectWrapper";
import { useAuthentication } from "./useAuthenticate";
import { messages } from "./utils";

export const AuthenticatePage = () => {
  const { methods, isLoading } = useAuthentication();

  return (
    <RedirectWrapper>
      <VerifyBox loading={isLoading}>
        <Typography variant="h5">
          <FormattedMessage {...messages.loginUsing} />
        </Typography>
        <AuthenticationMethodsList methods={methods} />
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Link component={NavLink} to={{ pathname: `/enroll/activate` }}>
            <FormattedMessage id="login.verify.code" defaultMessage="Enroll user and create a password" />
          </Link>
        </Box>
      </VerifyBox>
    </RedirectWrapper>
  );
};
